export const texts = {
  genderSuffix: {
    de: 'm|w|d',
    en: 'm|f|d'
  },
  analysis: {
    de: 'Analyse',
    en: 'Analysis'
  },
  applications: {
    de: 'Bewerbungen',
    en: 'applications'
  },
  profiles: {
    de: 'Profile',
    en: 'profiles'
  }
};
